function validateName(value) {
    const namePattern = /^[А-Яа-яA-Za-z]+$/;
    const matchName = value.match(namePattern);
    let isValidate;
    if (matchName && value.length >= 2) {
        isValidate = true;
    } else {
        isValidate = false;
    }
    return isValidate;
}

export default validateName;
